const selectWorkflow = state => {
  return {
    ...state.workflow
  };
};

export { selectWorkflow };
